export enum ARIA_REFS {
  BATTERY_HEADLINE = 'battery-headline',
  BATTERY_CHARGER_LABEL = 'battery-charger-label',
  BATTERY_CHARGING_VALUE_CONTROL = 'battery-charging-value-control',
  BATTERY_CHARGING_OPTIONS = 'battery-charging-options',
  BATTERY_MILEAGE = 'battery-mileage',
  BATTERY_INFOTEXT = 'battery-infotext',
}

export const getMultiRefsStringified = (...ariaRefs: ARIA_REFS[]): string => {
  return ariaRefs.join(' ');
};
